<div class="status-bar">
  <div>
    <div class="text">
      <p data-testid="status-bar-counter"> {{ total_answered }} of {{ totalQuestions }} answered</p>
    </div>
    <mat-progress-bar class="progress" mode="determinate" color="white" [value]="percentage"></mat-progress-bar>
  </div>
</div>